import { NavLink } from 'react-router-dom';
import { Building2, Users, ShieldCheck } from 'lucide-react';
import { usePermissions } from '@/hooks/usePermissions';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/accounts', label: 'Cuentas', icon: Building2, permission: 'accounts.view' as const },
  { to: '/users', label: 'Usuarios', icon: Users, permission: 'users.view' as const },
  { to: '/roles', label: 'Roles', icon: ShieldCheck, permission: 'users.manage_roles' as const },
];

export function AccountsTabs() {
  const { can } = usePermissions();
  const visibleTabs = TABS.filter((tab) => can(tab.permission));

  if (visibleTabs.length <= 1) return null;

  return (
    <nav className="flex items-center gap-1 border-b border-border px-6 pt-4 shrink-0">
      {visibleTabs.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end
          className={({ isActive }: { isActive: boolean }) =>
            cn(
              'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px',
              isActive
                ? 'border-amber-500 text-amber-500'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
            )
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
